var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.42969,
    y: 3.71289,
    width: 1.42857,
    height: 20,
    transform: "rotate(-45 2.42969 3.71289)",
    fill: "#9B9B9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.71875,
    y: 17.8555,
    width: 1.42857,
    height: 20,
    transform: "rotate(-135 3.71875 17.8555)",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAlert);
export default __webpack_public_path__ + "static/media/close_alert.0da1514fd289ae09e1fa2ec9c275c4bb.svg";
export { ForwardRef as ReactComponent };